import {alpha, Badge, Box, Card, CardContent, IconButton, Stack, Tooltip, Typography} from "@mui/material"
import {Mensaje, MensajeFields} from "../../types"

import {dateFormatter} from "src/utils/formatters"

import CustomChip from 'src/@core/components/mui/chip'
import LaunchIcon from '@mui/icons-material/Launch';
import {EntityWithIdFields} from "src/types"
import {useNavigate} from "react-router-dom";
import {rutaPorCodSistema} from "src/pages/sistema/RefactorLayout"
import {Icon} from "@iconify/react"
import MessageHeader from "./MessageHeaderDesktop";

interface MessageCardProps {
  message: Mensaje
}

const MessageCard = ({message}: MessageCardProps) => {
  const navigate = useNavigate()

  const {
    [EntityWithIdFields.Id]: messageId,
    [MensajeFields.CodSistemaTipo]: codSistema,
    [MensajeFields.NombreSistema]: nombreSistema,
    [MensajeFields.Referencia]: referencia,
    [MensajeFields.FechaIngresoEtapa]: stringFechaIngresoEtapa,
    [MensajeFields.NombreEtapaActual]: nombreEtapaActual,
    [MensajeFields.FechaCreacion]: stringFechaCreacion,
    [MensajeFields.NombreSistemaPrincipal]: nombreSistemaPrincipal,
    [MensajeFields.CodigoSistemaPrincipal]: idSistemaPrincipal,
    [MensajeFields.BitAbierto]: bitAbierto,
    [MensajeFields.DiasEnEtapa]: diasEnEtapa,
    [MensajeFields.HexColor]: hexColor,
    [MensajeFields.Estado]: estado,
    [MensajeFields.CodEtapaEstado]: etapaEstado, // Para saber si esta en curso
  } = message

  const fechaIngresoEtapa = dateFormatter.toShortDate(stringFechaIngresoEtapa);
  const fechaCreacion = dateFormatter.toShortDate(stringFechaCreacion);

  return (
    <Card sx={{
      height: '100%',
      borderRadius: '16px',
      border: '1px solid',
      borderColor: 'divider',
      borderTop: `3px solid ${hexColor || '#4f46e5'}`,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      transition: 'all 0.22s ease',
      '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: `0 14px 28px ${alpha(hexColor || '#4f46e5', 0.18)}`,
      },
    }}>
      <MessageHeader
        idSistemaPrincipal={idSistemaPrincipal}
        nombreSistema={nombreSistema}
        nombreSistemaPrincipal={nombreSistemaPrincipal}
        referencia={referencia}
        nombreEtapaActual={nombreEtapaActual}
        action={
          <Tooltip title='Abrir operación'>
            <IconButton onClick={() => navigate(`/operacion/${rutaPorCodSistema[codSistema]}/${messageId}`)}>
              <Badge color='error' variant='dot' invisible={bitAbierto}>
                <LaunchIcon/>
              </Badge>
            </IconButton>
          </Tooltip>
        }
      />
      <CardContent>
        <Stack spacing={2}>
          <CustomChip
            rounded
            size='small'
            skin='light'
            sx={{
              width: '100%',
              height: 'auto',
              py: 1,
              px: 1.5,
              borderRadius: '10px',
              '& .MuiChip-label': {
                fontWeight: 600,
                fontSize: 12,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 2,
                lineHeight: '1.5',
                whiteSpace: 'normal',
              },
              '& .MuiChip-avatar': {
                width: '10px !important',
                height: '10px !important',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              },
            }}
            label={estado}
            avatar={
              <Icon
                icon='mdi:circle'
                color={hexColor}
                style={{width: '8px', height: '8px'}}
              />
            }
          />
          <Stack direction={'column'} gap={0.5}
                 sx={{fontSize: '0.75rem'}}
          >

            <Stack direction={'row'} gap={1}>
              <Typography variant='body2'
                          sx={{fontSize: 'inherit'}}
              >Ingreso etapa:</Typography>
              <Typography variant='body1'
                          sx={{fontSize: 'inherit'}}
              >
                {fechaIngresoEtapa}
              </Typography>
              {
                etapaEstado === 1 &&
                  <CustomChip
                      sx={{fontSize: '0.75em', p: 0}}
                      size='small'
                      skin='light'
                      color={diasEnEtapa < 6 ? 'success' : diasEnEtapa < 20 ? 'warning' : 'error'}
                      label={diasEnEtapa == 0 ? 'hoy' : `hace ${diasEnEtapa} día${diasEnEtapa > 1 ? 's' : ''}`}

                    // label={daysToNaturalLanguage(diasEnEtapa)}
                  />
              }
            </Stack>

            <Stack direction={'row'} gap={1}>

              <Typography variant='body2'
                          sx={{fontSize: 'inherit'}}
              >Creación:</Typography>
              <Box sx={{mt: 0.25}}>
                <Typography variant='body1'
                            sx={{fontSize: 'inherit'}}
                >
                  {fechaCreacion}
                </Typography>
              </Box>

            </Stack>

            <Stack direction={'row'} gap={1}>
              <Typography variant='body2'
                          sx={{fontSize: 'inherit'}}
              >Id:</Typography>
              <Typography variant='body1'
                          sx={{fontSize: 'inherit'}}
              >
                {messageId}
              </Typography>
            </Stack>

          </Stack>

        </Stack>
      </CardContent>
    </Card>

  )
}

export default MessageCard
